import SEO from "@/components/site/SEO";

export default function Blog() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-24 text-center" data-testid="blog-page">
      <SEO title="Journal" description="Real estate market notes, funding strategy, and cash-flow wisdom from Hannah Howard." path="/blog" />
      <span className="overline">Insights</span>
      <h1 className="font-serif-lux text-5xl mt-4">The Hannah Howard Journal</h1>
      <p className="mt-6 text-[#5A3B31] leading-relaxed">
        Real estate market notes, funding strategy, and cash-flow wisdom for growing agents.
      </p>
      <div className="lux-card mt-14 p-14">
        <p className="font-serif-lux text-2xl">Articles coming soon.</p>
        <p className="text-sm text-[#8C7A70] mt-3">We're preparing thoughtful content for real estate professionals.</p>
      </div>
    </div>
  );
}
